import { normalize } from 'normalizr';
import moment from 'moment-timezone';
import { weployer as weployerSchema } from './schema';
import {
  DASHBOARD_JOBS_FETCH_SUCCESS,
  DASHBOARD_INSIGHT_NOTIFICATIONS_FETCH_SUCCESS,
  DASHBOARD_FEED_NOTIFICATIONS_FETCH_SUCCESS,
  JOB_DISMISS_CLICK,
  JOB_EXPIRE,
  NOTIFICATION_DISMISS_CLICK,
  NOTIFICATION_ACTION_CLICK,
  PAST_JOBS_FETCH_SUCCESS,
} from './actionTypes';
import {
  expireJob,
} from './mappers';
import { EXPIRED } from './graphql/constants';

export const initialState = {
  timesheets: undefined,
  orderedTimesheetIds: [],
  positions: {},
  weployees: {},
  jobs: {},
  notifications: {},
  deeplinkedTimesheetId: undefined,
};

const mergeStore = (prevStore, newStore, reset = false) => {
  const {
    timesheets,
    orderedTimesheetIds,
    weployees,
    jobs,
    positions,
    notifications,
  } = reset ? initialState : prevStore;

  return {
    timesheets: { ...timesheets, ...newStore.timesheets },
    weployees: { ...weployees, ...newStore.weployees },
    jobs: { ...jobs, ...newStore.jobs },
    positions: { ...positions, ...newStore.positions },
    notifications: { ...notifications, ...newStore.notifications },
    orderedTimesheetIds: [...orderedTimesheetIds, ...(newStore.orderedTimesheetIds || [])],
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case DASHBOARD_JOBS_FETCH_SUCCESS: {
      const { payload, reset } = action;
      const newStore = normalize(payload, weployerSchema).entities;

      return mergeStore(state, newStore, reset);
    }
    case DASHBOARD_INSIGHT_NOTIFICATIONS_FETCH_SUCCESS:
    case DASHBOARD_FEED_NOTIFICATIONS_FETCH_SUCCESS: {
      const { payload, reset } = action;
      const newStore = normalize(payload, weployerSchema).entities;

      return mergeStore(state, newStore, reset);
    }
    case PAST_JOBS_FETCH_SUCCESS: {
      const { payload } = action;
      const newStore = normalize(payload, weployerSchema).entities;

      return mergeStore(state, newStore);
    }
    case JOB_EXPIRE: {
      const prevStore = state;
      const { id } = action;
      return {
        ...prevStore,
        jobs: { ...expireJob(prevStore.jobs, id) },
      };
    }
    case JOB_DISMISS_CLICK: {
      const prevStore = state;
      const { id } = action;
      const dismissedJob = { ...prevStore.jobs[id] };
      dismissedJob.status = EXPIRED;

      return {
        ...prevStore,
        jobs: { ...prevStore.jobs, [id]: dismissedJob },
      };
    }
    case NOTIFICATION_DISMISS_CLICK: {
      const newStore = { ...state, notifications: { ...state.notifications } };
      delete newStore.notifications[action.notificationId];

      return newStore;
    }
    case NOTIFICATION_ACTION_CLICK: {
      const newStore = { ...state, notifications: { ...state.notifications } };
      const notification = newStore.notifications[action.notificationId];
      notification.actionedBy = 'You';
      notification.actionedAt = moment().format('YYYY-MM-DDTHH:mm:ssZ');

      return newStore;
    }
    default:
      return state;
  }
};

export default {
  initialState,
  reducer,
};
